import Splide from '@splidejs/splide';

if(document.querySelector('.message')){


new Splide( '.splide',{
    type: 'loop',
    autoplay: true,
    arrows: false,
    pagination: false,
    perPage: 1
}).mount();

}